import React from 'react';

import { Container } from './styles';

const LineSeparator = props => <Container {...props} />;

export default LineSeparator;
